import React from 'react'
import styled from '@emotion/styled'

import IconButton from '../IconButton'

const Root = styled.div`
  display: flex;
`

const IconButtonBin = styled.div`
  flex-shrink: 0;
  padding: 0 9px;  
`

const listIcon = <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 211.93416 211.93416">
  <rect y="6" width="43.41564" height="43.41564"/>
  <rect x="60" y="6" width="151.93416" height="43.41564"/>
  <rect y="85" width="43.41564" height="43.41564"/>
  <rect x="60" y="85" width="151.93416" height="43.41564"/>
  <rect y="162" width="43.41564" height="43.41564"/>
  <rect x="60" y="162" width="151.93416" height="43.41564"/>
</svg>


const cardsIcon = <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 211.93416 211.93416">
  <rect x="6.05761" y="5.76543" width="88.93107" height="88.93107"/>
  <rect x="117.05761" y="5.76543" width="88.93107" height="88.93107"/>
  <rect x="117.05761" y="116.76543" width="88.93107" height="88.93107"/>
  <rect x="6.05761" y="116.76543" width="88.93107" height="88.93107"/>
</svg>


const tableIcon = <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 211.93416 211.93416">
  <rect x="0.05761" y="5.76543" width="211.87654" height="28.33539"/>
  <rect x="0.05761" y="176.76543" width="211.87654" height="28.33539"/>
  <rect x="0.05761" y="119.76543" width="211.87654" height="28.33539"/>
  <rect x="0.05761" y="62.76543" width="211.87654" height="28.33539"/>
</svg>


const ViewBar = ({viewType, setViewType}) => <Root>
  <IconButtonBin title="Показывать списком"><IconButton svgIcon={listIcon} handleClick={() => setViewType('list')} active={viewType === 'list'}/></IconButtonBin>
  <IconButtonBin title="Показывать карточками"><IconButton svgIcon={cardsIcon} handleClick={() => setViewType('cards')} active={viewType === 'cards'}/></IconButtonBin>
  <IconButtonBin title="Показывать таблицей"><IconButton svgIcon={tableIcon} handleClick={() => setViewType('table')} active={viewType === 'table'}/></IconButtonBin>
</Root>

export default ViewBar
